import {Component, inject, input} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';

import {PermissionsService} from '@intocare/auth-data';

import {StatisticsFacadeService} from '../../statistics-facade.service';

@Component({
	selector: 'ic-call-signal-overview-card',
	templateUrl: './call-signal-overview.component.html',
	styleUrls: ['./call-signal-overview.component.scss'],
	standalone: false
})
export class CallSignalOverviewComponent {
	private facadeService = inject(StatisticsFacadeService);
	private permissionsService = inject(PermissionsService);

	date = input<string>(undefined);
	canViewDashboardAlarms = this.permissionsService.userHasPermissions('PORTAL.ALARMS_WIDGET');
	protected statisticsQuery = this.canViewDashboardAlarms
		? injectQuery(this.facadeService.getAllStatisticsQueryOptions(this.date))
		: undefined;
}
